import { useEffect } from "react";
import Router from "./Routes/Index";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { QueryClientProvider } from "@tanstack/react-query";
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer } from "react-bootstrap";
import { QueryClient } from "@tanstack/react-query";
import useAppStore from "./store/global";

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });

function App() {
  const theme = useAppStore((state) => state.theme);

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <div className="App">
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </div>
    </QueryClientProvider>
  );
}

export default App;
